export const cardItemsInitial = [
    {
        titlePath: "navigation.krok.title",
        titleConst: "krok",
        descriptionPath: "navigation.krok.description",
        link: "studentQuizRoot",
        color: "green darken-3",
        role: ["quizStep"],
    },
];